module.exports = __webpack_public_path__ + "assets/login_bg2.45d195b7.svg";